import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

// @material-ui/core components
import { Checkbox, Tooltip, IconButton, Table, TableRow, TableBody, TableCell } from "@mui/material";

// @mui/icons-material
import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import Check from "@mui/icons-material/Check";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/tasksStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function Tasks(props) {

  const [checked, setChecked] = React.useState([...props.checkedIndexes]);

  const handleToggle = value => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const { tasksIndexes, tasks, rtlActive } = props;

  const tableCellData = {
    "tableCellRTL": rtlActive
  }
  const tableCellKeys = getKeyArray(tableCellData);



  return (
    <Table sx={styles.table}>
      <TableBody>
        {tasksIndexes.map(value => (
          <TableRow key={value} sx={styles.tableRow}>
            <TableCell sx={getBaseSxStyle(styles, [...tableCellKeys])}>
              <Checkbox
                checked={checked.indexOf(value) !== -1}
                tabIndex={-1}
                onClick={() => handleToggle(value)}
                checkedIcon={<Check sx={styles.checkedIcon} />}
                icon={<Check sx={styles.uncheckedIcon} />}
                sx={getBaseSxStyle(styles, ['checked', 'root'])}
              />
            </TableCell>
            <TableCell sx={getBaseSxStyle(styles, [...tableCellKeys])}>{tasks[value]}</TableCell>
            <TableCell sx={styles.tableActions}>
              <Tooltip
                sx={getBaseSxStyle(styles, ['tooltip'])}
                id="tooltip-top"
                title="Edit Task"
                placement="top"
              >
                <IconButton
                  aria-label="Edit"
                  sx={styles.tableActionButton}
                >
                  <Edit sx={getBaseSxStyle(styles, ['tableActionButtonIcon', 'edit'])} />
                </IconButton>
              </Tooltip>
              <Tooltip
                sx={getBaseSxStyle(styles, ['tooltip'])}
                id="tooltip-top-start"
                title="Remove"
                placement="top"
              >
                <IconButton
                  sx={getBaseSxStyle(styles, ['tableActionButton'])}
                  aria-label="Close"
                >
                  <Close sx={getBaseSxStyle(styles, ['tableActionButtonIcon', 'close'])} />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

Tasks.propTypes = {
  tasksIndexes: PropTypes.arrayOf(PropTypes.number),
  tasks: PropTypes.arrayOf(PropTypes.node),
  rtlActive: PropTypes.bool,
  checkedIndexes: PropTypes.array
};
